import React from 'react';
import { Locale, ViewMode } from '../types';
import { SiteContent } from '../data/content';
import { Header } from './Header';
import { SignalPathFlow } from './SignalPathFlow';

interface HeroProps {
  locale: Locale;
  onLocaleChange: (locale: Locale) => void;
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  siteContent: SiteContent;
  onViewExperience: () => void;
}

export const Hero: React.FC<HeroProps> = ({
  locale,
  onLocaleChange,
  viewMode,
  onViewModeChange,
  siteContent,
  onViewExperience,
}) => {
  const { hero, signalNodes } = siteContent;

  return (
    <header className="hero" id="hero">
      <Header
        locale={locale}
        onLocaleChange={onLocaleChange}
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        siteContent={siteContent}
      />

      <div className="hero-main">
        <div className="hero-body">
          <p className="hero-eyebrow">{hero.eyebrow}</p>
          <h1 id="hero-title" className="hero-headline">
            {hero.headlineLead}
            <br />
            <span className="emph">{hero.headlineEmph}</span>
          </h1>
          <p className="hero-sub">{hero.summary}</p>
          <div className="hero-actions">
            <button
              type="button"
              className="hero-btn hero-btn--primary"
              onClick={onViewExperience}
            >
              {hero.viewExpButton}
              <span aria-hidden="true">↗</span>
            </button>
            <a
              href="mailto:dmitry@yakovlefff.ru"
              className="hero-btn hero-btn--ghost"
            >
              {hero.contactButton}
            </a>
          </div>
        </div>

        <aside className="hero-aside" aria-label="Interactive support system pipeline">
          <SignalPathFlow nodes={signalNodes} heroContent={hero} />
        </aside>
      </div>

      <div className="hero-foot">
        <div className="hero-foot-tag">
          <span>SUPPORT SYSTEMS · INCIDENT OPERATIONS · OBSERVABILITY</span>
        </div>
        <div className="hero-meta">
          <span className="dot" aria-hidden="true" />
          <span>{hero.availability}</span>
        </div>
      </div>
    </header>
  );
};
